import React from 'react';
import Header from './Header';
import HomeRef from './HomeRef';
import { Link } from 'react-router-dom'
import { GIFT_CARD_SVG, REWARD_LIST_SVG } from '../staticTypes';
import {trackSharePop} from '../../Utils/blogs'

const Referral = (props) => {
	const { points, emailShareUrl, facebookShareUrl, insShareUrl, shareLink } = props.data;
	
	const {onClick, launcherFlag, email, visitorId} = props
	
	const onRefCompleted = () => {
		trackSharePop(email, visitorId, 'ref-completed-page')
	}
	
	return (
		<div id="referral" className="referral">
			<Header points={points} onClick={onClick} launcherFlag={launcherFlag}  link="/" />
			<div className="panel-container with-wantdo-footer">
				<div className="panel-subview earning-rules-card">
					<div className="card-heading-container">
						<div className="card-title heading ">Referrals</div>
						<Link to="/referral-list" className="history activity-button" aria-label="Referral history" onClick={onRefCompleted}>
							{REWARD_LIST_SVG}
						</Link>
					</div>
					<div className="card-description">Give your friends a reward and claim your own when they make a purchase.</div>
					<div className="card-list-container with-border-bottom mb-6 no-hover">
						<div className="card-list-item-container ">
							<div className="card-list-item " aria-label="They get">
								<div className="card-list-item-content">
									{GIFT_CARD_SVG}
								<div className="list-item-text-wrapper">
										<div className="list-item-title">They get</div>
										<div className="list-item-subtitle text-muted">$15 off coupon</div>
									</div>
								</div>
							</div>
						</div>
						<div className="card-list-item-container ">
							<div className="card-list-item " aria-label="You get">
								<div className="card-list-item-content">
									{GIFT_CARD_SVG}
									<div className="list-item-text-wrapper">
										<div className="list-item-title">You get</div>
										<div className="list-item-subtitle text-muted">$15 off coupon</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="heading pl-3 mb-4">Your referral code</div>
					<HomeRef 
						emailShareUrl={emailShareUrl} 
						facebookShareUrl={facebookShareUrl} 
						insShareUrl={insShareUrl} 
						shareLink={shareLink} 
						visitorId = {visitorId}
						email = {email}
					/>
				</div>
			</div>
		</div>
	)
}

export default Referral;